import type { FlowScreens } from "./types";
import { Flow, OtherScreens } from "./types";
import { VerificationNames } from "shared/types";

export const flows: Record<Flow, FlowScreens[]> = {
  [Flow.BypassHomeScreen]: [
    VerificationNames.TermsAndConditions,
    OtherScreens.Invite,
    OtherScreens.MoveInDate,
    VerificationNames.RentalApplication,
    VerificationNames.HousingHistory,
    VerificationNames.IdentityVerification,
    VerificationNames.IncomeVerification,
    VerificationNames.VerifiedIncomeVerification,
    VerificationNames.SubmissionDisclosure,
    OtherScreens.CheckOut
  ],
  [Flow.Default]: []
};
